// 对话数据
import { getTreatmentDayitemNext, dayitemStepsubmit, getTreatmentDayitem } from '@/api/dialogue'
import { Dialog } from 'vant';
import Router from '@/router'
export default {
  state: {
    dialogueListAll: [],
    countermeasureCardList: [], // 子任务 对话列表 通用
    currentIndex: 0,
    description: '', // 背景
    trouble_tag: '' // 问题分类
  },
  getters: {
  },
  mutations: {
    setDialogueListAll(state, payload) {
      state.dialogueListAll = payload
    },
    // 设置目标与动机list
    setCountermeasureCardList(state, payload) {
      state.countermeasureCardList = payload
    },
    setCurrentIndex(state, payload) {
      state.currentIndex = payload
    },
    setDescription(state, payload) {
      state.description = payload
    },
    setTroubleTag(state, payload) {
      state.trouble_tag = payload
    }
    
  },
  actions: {
    // 获取子任务历史
    async getTreatmentDayitemCountermeasure({ state, commit, dispatch }, payload) {
      try {
        commit('setCountermeasureCardList', [])
        commit('setDialogueListAll', [])
        commit('setCurrentIndex', 0)
        const resData = await getTreatmentDayitem(payload);
        if(resData.length) {
          let useData = []
          resData.filter(item => !!item.message).forEach(item => {
            const itemData = JSON.parse(item.message)
            console.log(itemData)
            if(itemData.step_type === 'SYS_INFO') {
              Dialog({
                message: itemData.step_data.content
              }).then(() => {
                Router.back()
              });
              return;
            }
            if(itemData.step_type === "strategy_practice_survey") {
              useData = itemData.step_data.questions
              commit('setDialogueListAll', useData);
              commit('setDescription', itemData.step_data.description);
              commit('setTroubleTag', itemData.step_data.trouble_tag);
            }
          });
          if(!useData.length) return;
          let index = state.currentIndex;
          let cardData = {}
          const pushData = function() {
            setTimeout(async () => {
              if(useData[index]?.qstContext.type === 'input') {
                if(useData[index]?.qstContext.info === 'l') {
                  cardData = {
                    ...useData[index],
                    type: 'ChatText',
                    text: useData[index]?.qstContext.props.placeholder,
                    cardMode: 'dialogue', // dialogue 对话 card 卡片
                    colourMode: "default",
                    isShowTime: false,
                  }
                }
                if(useData[index]?.qstContext.info === 'r') {
                  cardData = {
                    ...useData[index],
                    type: 'ChatSend',
                    text: useData[index]?.qstContext.props.placeholder,
                    isShowTime: false,
                  }
                }
              }
              if(useData[index]?.qstContext.type === 'tree') {
                cardData = {
                  ...useData[index],
                  type: 'ChatConfirmMore',
                  data: useData[index]?.qstContext.props.data,
                  isShowTime: false,
                }
              }
              await commit('setCountermeasureCardList', [
                ...state.countermeasureCardList,
                cardData
              ])
              cardData = {};
              if((useData.length - 1) !== index && useData[index].qstContext.type !== 'tree') {
                pushData()
                index++
              } else {
                commit('setCurrentIndex', index + 1)
              }
              setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight);
              }, 100)
            }, 500);
          }
          pushData()
        } else if (resData.length === 0) {
          dispatch('getTreatmentDayitemNextCountermeasure', payload)
        }
        return resData;
      } catch (error) {
        console.log(error)
        return false;
      }
    },
    // 获取子任务下一项内容
    async getTreatmentDayitemNextCountermeasure({ state, commit }, payload) {
      try {
        const resData = await getTreatmentDayitemNext(payload);
        console.log('resData', resData)
        if(resData.step_type === 'SYS_INFO') {
          Dialog({
            message: resData.step_data.content
          }).then(() => {
            Router.back()
          });
          return;
        }
        if(resData.step_type === "strategy_practice_survey") {
          let useData = []
          useData = resData.step_data.questions
          commit('setDialogueListAll', useData);
          commit('setDescription', resData.step_data.description);
          commit('setTroubleTag', resData.step_data.trouble_tag);
          let index = 0;
          let cardData = {}
          const pushData = function() {
            setTimeout(async () => {
              console.log(useData[index], useData)
              if(useData[index]?.qstContext.type === 'input') {
                if(useData[index].qstContext.info === 'l') {
                  cardData = {
                    ...useData[index],
                    type: 'ChatText',
                    text: useData[index].qstContext.props.placeholder,
                    cardMode: 'dialogue', // dialogue 对话 card 卡片
                    colourMode: "default",
                    isShowTime: false,
                  }
                }
                if(useData[index].qstContext.info === 'r') {
                  cardData = {
                    ...useData[index],
                    type: 'ChatSend',
                    text: useData[index].qstContext.props.placeholder,
                    isShowTime: false,
                  }
                }
              }
              if(useData[index].qstContext.type === 'tree') {
                cardData = {
                  ...useData[index],
                  type: 'ChatConfirmMore',
                  data: useData[index].qstContext.props.data,
                  isShowTime: false,
                }
              }
              await commit('setCountermeasureCardList', [
                ...state.countermeasureCardList,
                cardData
              ])
              cardData = {};
              if((useData.length - 1) !== index && useData[index].qstContext.type !== 'tree') {
                pushData()
                index++
              } else {
                commit('setCurrentIndex', index + 1)
              }
              setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight);
              }, 100)
            }, 500);
          }
          pushData()
        }
        return resData
      } catch (error) {
        console.log(error)
        return false;
      }
    },

    // 子任务提交
    async dayitemStepsubmitCountermeasure(_, payload) {
      try {
        const resData = await dayitemStepsubmit(payload);
        return resData;
      } catch (error) {
        console.log(error)
      }
    },

    // 消息发送记录
    async sednMsgCountermeasure({ state, commit }, payload) {
      console.log(state,commit,payload);
      try {
        const useList = [
          ...state.countermeasureCardList,
          payload
        ]
        commit('setCountermeasureCardList', useList);
        let useData = state.dialogueListAll;
        let index = state.currentIndex;
        let cardData = {}
        const pushData = function() {
          setTimeout(async () => {

            if(index < state.currentIndex) {
              console.log("当前操作落后于实际：", index,"|", state.currentIndex);
              return;
            }
            //console.log("index:" ,index, "type:", useData[index]?.qstContext.type ,"  text:", useData[index]?.qstContext.props.placeholder);
            if(useData[index]?.qstContext.type === 'input') {
              if(useData[index]?.qstContext.info === 'l') {
                cardData = {
                  ...useData[index],
                  type: 'ChatText',
                  text: useData[index]?.qstContext.props.placeholder,
                  cardMode: 'dialogue', // dialogue 对话 card 卡片
                  colourMode: "default",
                  isShowTime: false,
                }
              }
              if(useData[index]?.qstContext.info === 'r') {
                cardData = {
                  ...useData[index],
                  type: 'ChatSend',
                  text: useData[index]?.qstContext.props.placeholder,
                  isShowTime: false,
                }
              }
            }
            if(useData[index]?.qstContext.type === 'tree') {
              cardData = {
                ...useData[index],
                type: 'ChatConfirmMore',
                data: useData[index]?.qstContext.props.data,
                isShowTime: false,
              }
            }
            await commit('setCountermeasureCardList', [
              ...state.countermeasureCardList,
              cardData
            ])
            cardData = {};
            if((useData.length - 1) !== index && useData[index]?.qstContext.type !== 'tree') {
              commit('setCurrentIndex', index + 1)
              pushData()
              index++
            } else {
              commit('setCurrentIndex', index + 1)
            }
            setTimeout(() => {
              window.scrollTo(0, document.body.scrollHeight);
            }, 100)
          }, 500);
        }
        pushData();
        return true;
      } catch (error) {
        console.log(error)
        return false;
      }
     },
  }
}
